export const PROD = false;

export const STATIC_FILE_URL = process.env.REACT_APP_STATIC_URL
export const STATIC_LOCAL_FILE_URL = process.env.REACT_APP_STATIC_LOCAL_URL
export const PUBLIC_URL = process.env.REACT_APP_PUBLIC_URL
export const API_URL = process.env.REACT_APP_API_URL
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL

export const SSO_KEY = process.env.REACT_APP_SSO_KEY
export const SSO_URL = process.env.REACT_APP_SSO_URL

// Regional HVAC Page
export const CTM_URL = process.env.REACT_APP_CTM_URL

// Proxy API (Bypass CORS)
export const PROXY_API = `${API_URL}/proxy`

// Support API
export const SUPPORT_API = `${API_URL}/supports`

// Authentication API
export const LOGIN_API =`${API_URL}/token`;
export const VERIFY_URL = `${API_URL}/token/verify`;
export const REFRESH_TOKEN_API = `${API_URL}/token/refresh`;
export const LOGOUT_API = `${API_URL}/token/logout`;

// Not Defined
export const FORGET_PASSWORD_API = `${API_URL}/ForgetPassword`;

// Common API
export const BUILDINGS_API = `${API_URL}/buildings`
export const BUILDING_TYPES_API = `${API_URL}/building_types`
export const REGIONS_API = `${API_URL}/regions`
export const HOLIDAY_API = `${API_URL}/holidays`
export const MONTHLY_REPORTS_API = `${API_URL}/reports`
export const BUILDING_REPORT_API = `${API_URL}/buildings/{0}/reports`
export const CUSTOMIZAIION_API = `${API_URL}/customizations/{0}`
export const CUSTOMIZAIION_UPDATE_API = `${API_URL}/customizations/{0}/update`

// Employee API
export const EMPLOYEES_API = `${API_URL}/employees`
export const EMPLOYEE_API = `${API_URL}/employees/{0}`
export const EMPLOYEE_BUILDING_API = `${API_URL}/employees/{0}/buildings`
export const EMPLOYEE_SLA_API = `${API_URL}/employees/{0}/sla`
export const EMPLOYEE_CLIENT_API = `${API_URL}/employees/{0}/clients`
export const EMPLOYEE_INSEPECTOR_API = `${API_URL}/employees/{0}/inspectors`

// Building System Related API
export const SYSTEM_API = `${API_URL}/buildings/{0}/systems/{1}`
export const SYSTEM_ASSET_API = `${API_URL}/buildings/{0}/systems/{1}/assets`
export const SYSTEM_ASSET_AVAIL_API = `${API_URL}/buildings/{0}/systems/{1}/assets/availability`
export const SYSTEM_ASSET_TREND_API = `${API_URL}/buildings/{0}/systems/{1}/assets/{2}/trend`

// Alarm API
export const ALARM_COUNT_API = `${API_URL}/alarms`
export const ALARM_TREND_API = `${API_URL}/alarms/trend`
export const ALARM_RECORDS_API = `${API_URL}/alarms/{0}/records`

// Application System API
export const APPLICATION_SYSTEMS_API = `${API_URL}/application_systems`

// Energy API
export const REGION_ENERGY_USAGE = `${API_URL}/energy/usage/compare`
export const BUILDING_ENERGY_USAGE_API = `${API_URL}/buildings/{0}/energy/usage/compare`
export const BUILDING_TX_USAGE_API = `${API_URL}/buildings/{0}/energy/tx/usage`
export const BUILDING_SYSTEM_ENERGY_USAGE_API = `${API_URL}/buildings/{0}/systems/{1}/energy/usage/compare`
export const BUILDING_CARBON_EMISSION_API = `${API_URL}/buildings/{0}/energy/carbon_emission`
export const BUILDING_SYSTEM_CARBON_EMISSION_API = `${API_URL}/buildings/{0}/systems/{1}/energy/carbon_emission`
export const BUILDING_EUI_API = `${API_URL}/buildings/{0}/energy/eui`
export const BUILDING_SYSTEM_EUI_API = `${API_URL}/buildings/{0}/systems/{1}/energy/eui`

// Point Trend and Summary
export const POINT_TREND = `${API_URL}/points/trend`
export const POINT_SUMMARY = `${API_URL}/points/summary`

export const BUILDING_CHILLER_PERFORMANCE_CURVE_API = `${API_URL}/metric/get-data-from-db`;

// Weather API
export const WEATHER_CURRENT_DATA_API = 'https://data.weather.gov.hk/weatherAPI/opendata/weather.php?dataType=rhrread&lang=en';
export const WEATHER_FORECAST_DATA_API = 'https://data.weather.gov.hk/weatherAPI/opendata/weather.php?dataType=fnd&lang=en';
export const WEATHER_WARNING_DATA_API = 'https://data.weather.gov.hk/weatherAPI/opendata/weather.php?dataType=warnsum&lang=en';

export const WEATHER_API = `${API_URL}/weather/`

// Live TV API
export const NOWTV_LIVE_FEED_API = 'http://d1jithvltpp1l1.cloudfront.net/getLiveURL'
export const RTHK_LIVE_FEED_API = 'https://rthklive2-lh.akamaihd.net/i/rthk32_1@168450/index_1080_av-b.m3u8?sd=10&rebase=on'

// Custom Arcgis Feature Layer API
export const ARCGIS_APP_AUTH_API = `${API_URL}/maps/arcgis/token`
export const CCTV_API = `${API_URL}/maps/cctv`;
export const LIFT_API = `${API_URL}/maps/lift`;
export const FIRE_ALARM_API = `${API_URL}/maps/fire_alarm`
export const PV_PANEL_API = `${API_URL}/maps/pv`
export const PV_PANEL_DISTRIBUTION_API = `${API_URL}/maps/pv/distribution`

export const PIPE_API = `${API_URL}/maps/pipe`
export const HKO_STATION_TEMPERATURE_API = `${API_URL}/maps/hko_temp`

// Arcgis Map Living Atlas Feature Layer API
export const TD_SPEEDCAM_FEATURE_API = `https://services3.arcgis.com/6j1KwZfY2fZrfNMR/arcgis/rest/services/TD_SpeedMap/FeatureServer/0`
export const HKO_TEMPERATURE_FEATURE_API = `https://services3.arcgis.com/6j1KwZfY2fZrfNMR/arcgis/rest/services/HKO_Current_Temperature/FeatureServer/0`
export const EPD_CURRENT_AQHI_FEATURE_API = `https://services3.arcgis.com/6j1KwZfY2fZrfNMR/arcgis/rest/services/EPD_Current_AQHI/FeatureServer/0`
export const TRAFFIC_CAM_FEATURE_API = `https://services3.arcgis.com/6j1KwZfY2fZrfNMR/arcgis/rest/services/Traffic_Snapshot_Images_from_CCTV_in_Hong_Kong/FeatureServer/0`
export const CONFIRM_CASE_FEATURE_API = `https://services8.arcgis.com/PXQv9PaDJHzt8rp0/arcgis/rest/services/Merge_Buffer_0227_test_2_View/FeatureServer/0`
export const CTO_BOUNDARY_FEATURE_API = `https://services8.arcgis.com/PXQv9PaDJHzt8rp0/arcgis/rest/services/CTO_Boundary_View/FeatureServer/1`
export const CONPULSORY_BUILDING_FEATURE_API = `https://services8.arcgis.com/PXQv9PaDJHzt8rp0/arcgis/rest/services/CompulsoryTestingBuilding_View/FeatureServer/0`

// iBMS Point URL
export const IBMS_REF_PATH = `https://gesdibms.emsd.hksarg/enteliweb#/object/display?ObjRef=`

//User manual path
export const USER_MANUAL_PATH = `${STATIC_FILE_URL}/dashboard/user_manual/user_manual.pdf`;